var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');

var TableColumnFiltersView = Marionette.View.extend({
    template: require('../../templates/common/table-column-filters-view.html'),

    ui: {
        popover: '[data-toggle="popover"]',
        content: '#content',

        apply: '#apply',
        reset: '#reset',
        cancel: '#cancel',

        from: '#from',
        to: '#to',
        val: '#val',

        emptyOnlyCheckbox: "#empty-only",

        iconFilter: '.glyphicon-filter'
    },

    events: {
        'click @ui.apply': 'onApply',
        'click @ui.reset': 'onReset',
        'click @ui.cancel': 'onCancel',
        'change @ui.emptyOnlyCheckbox': "onEmptyOnlyChanged"
    },

    templateContext: function () {
        var that = this;
        return {}
    },

    initialize: function (options) {
        var that = this;
        that.utils = new CommonUtils();
        that.dateFormat = 'MM/DD/YYYY';
        that.activeColor = "red";
        that.inactiveColor = "blue";

        that.model = new Backbone.Model({
            filter: options.filter
        });

        that.list = options.list;
    },

    onRender: function () {
        var that = this;
        var filter = this.model.get('filter');

        $(document).ready(function () {
            that.ui.popover.popover({
                trigger: 'click',
                html: true,
                content: that.ui.content
            });

            if (filter.filterType == 'select') {
                that.selectizedVal = that.ui.val.selectize({
                    plugins: ['remove_button'],
                    inputClass: 'form-control selectize-input normal-width selectized val-selectize',
                    placeholder: 'Select',
                    valueField: 'value',
                    labelField: 'name',
                    options: that.list,
                    items: (that.list || []).map(function (item) {
                        if (filter.value && filter.value.includes(item.value)) return item.value;
                    }),//filter.value.split(",")([]).map(function (item) {return item.value;}), //function (){if(filter.value) return filter.value.split(","); else return [];}
                    highlight: true,
                    openOnFocus: true
                });
            }

            that.ui.popover.on('show.bs.popover', function () {
                that.ui.content.show();
            });

            that.ui.popover.on('hide.bs.popover', function () {
                that.ui.content.hide();
            });

            if (filter.dataType == 'date') {

                that.ui.from.datetimepicker({
                    showClear: true,
                    showClose: true,
                    format: that.dateFormat
                });
                that.ui.to.datetimepicker({
                    showClear: true,
                    showClose: true,
                    format: that.dateFormat
                });


                if (filter.filterType == 'interval') {
                    that.ui.from.data("DateTimePicker").date(that.utils.longToDateTimeFormatted(filter.from, that.dateFormat));
                    that.ui.to.data("DateTimePicker").date(that.utils.longToDateTimeFormatted(filter.to, that.dateFormat));
                } else {
                    that.ui.val.data("DateTimePicker").date(that.utils.longToDateTimeFormatted(filter.value, that.dateFormat));
                }
            }
            if (!_.isEmpty(filter.from)
                || !_.isEmpty(filter.to)
                || !_.isEmpty(filter.value)) {
                that.ui.iconFilter.css({color: that.activeColor});
            }

            window.setTimeout(function() {
                that.onApply("deferred");
            }, 1000);
        });
    },

    onApply: function (deferred) {

        var that = this;
        var filter = that.model.get('filter');
        var filterFunction;

        if (filter.onlyEmpty) {
            filterFunction = function (v) {
                return !v;
            };
        } else {
            if (filter.filterType == 'interval') {
                if (_.isEmpty(that.ui.from.val()) && _.isEmpty(that.ui.to.val())) {
                    filter.from = null;
                    filter.to = null;
                    filterFunction = null;
                } else if (!_.isEmpty(that.ui.from.val()) && _.isEmpty(that.ui.to.val())) {
                    filter.from = that.getConvertedValue(filter.dataType, that.ui.from.val());
                    filter.to = null;
                    filterFunction = function (v) {
                        return v >= filter.from;
                    };
                } else if (_.isEmpty(that.ui.from.val()) && !_.isEmpty(that.ui.to.val())) {
                    filter.from = null;
                    filter.to = that.getConvertedValue(filter.dataType, that.ui.to.val())+86340000;
                    filterFunction = function (v) {
                        return v <= filter.to;
                    };
                } else {
                    filter.from = that.getConvertedValue(filter.dataType, that.ui.from.val());
                    filter.to = that.getConvertedValue(filter.dataType, that.ui.to.val())+86340000;
                    filterFunction = function (v) {
                        return v >= filter.from && v <= filter.to;
                    };
                }
            } else if (filter.filterType == 'select' && !_.isEmpty(that.ui.val.val())) {
                filter.value = that.ui.val.val();
                filterFunction = function (v) {
                    try {
                        return v && filter.value.toLowerCase().includes(v.toLowerCase());
                    }
                    catch (e) {
                        console.log(e);
                    }
                };
            } else {
                if (_.isEmpty(that.ui.val.val())) {
                    filter.value = null;
                    filterFunction = null;
                } else {
                    filter.value = that.getConvertedValue(filter.dataType, that.ui.val.val());
                    if (filter.filterType == 'like') {
                        filterFunction = function (v) {
                            return (v || '').toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                        };
                    } else {
                        filterFunction = function (v) {
                            return v == filter.value;
                        };
                    }
                }
            }
        }

        that.triggerMethod('filter:changed', {
            columnFilter: filter,
            filterFunction: filterFunction,
            deferred: deferred == "deferred" ? true : false
        });

        if (filterFunction == null)
            that.ui.iconFilter.css({color: that.inactiveColor});
        else
            that.ui.iconFilter.css({color: that.activeColor});

        if (deferred != "deferred")
            that.ui.popover.click();
    },

    getConvertedValue: function (dataType, value) {
        var that = this;
        if (dataType == 'date') {
            return that.utils.stringDateToLong(that.dateFormat, value);
        }

        return value;
    },

    onReset: function () {
        var filter = this.model.get('filter');

        if (filter.filterType == 'interval') {
            this.ui.from.val(null);
            this.ui.to.val(null);

            filter.from = null;
            filter.to = null;
        } else if (filter.filterType == 'select') {
            this.ui.val["0"].selectize.clear();
            filter.value = null;
        } else {
            this.ui.val.val(null);
            filter.value = null;
        }

        this.emptyOnly(false);

        this.triggerMethod('filter:changed', {
            columnFilter: filter,
            filterFunction: null,
            deferred: false
        });

        this.ui.iconFilter.css({color: this.inactiveColor});
        this.ui.popover.click();
    },

    onCancel: function () {
        this.clearNewValues();
        this.ui.popover.click();
    },

    clearNewValues: function () {
        var filter = this.model.get('filter');
        if (filter.dataType == 'date') {
            if (filter.filterType == 'interval') {
                this.ui.from.data("DateTimePicker").date(this.utils.longToDateTimeFormatted(filter.from, this.dateFormat));
                this.ui.to.data("DateTimePicker").date(this.utils.longToDateTimeFormatted(filter.to, this.dateFormat));
            } else {
                this.ui.value.data("DateTimePicker").date(this.utils.longToDateTimeFormatted(filter.value, this.dateFormat));
            }
        } else {
            this.ui.from.val(filter.from);
            this.ui.to.val(filter.to);
            this.ui.val.val(filter.value);
        }
        this.ui.emptyOnlyCheckbox.prop('checked', filter.onlyEmpty);
    },

    onEmptyOnlyChanged: function (e) {
        var checked = e.target.checked;
        this.emptyOnly(checked);
    },

    emptyOnly: function (checked) {
        var that = this;
        var filter = this.model.get('filter');
        if (checked) {
            that.ui.from.attr('disabled', true);
            that.ui.to.attr('disabled', true);
            that.ui.val.attr('disabled', true);
            if (that.selectizedVal)
                that.selectizedVal[0].selectize.disable();
            that.ui.emptyOnlyCheckbox.prop('checked', true);
            filter.onlyEmpty = true;

        } else {
            that.ui.from.removeAttr('disabled');
            that.ui.to.removeAttr('disabled');
            that.ui.val.removeAttr('disabled');
            if (that.selectizedVal)
                that.selectizedVal[0].selectize.enable();
            that.ui.emptyOnlyCheckbox.prop('checked', false);
            filter.onlyEmpty = false;
        }
    }
});

module.exports = TableColumnFiltersView;


//////////////////
// WEBPACK FOOTER
// ./app/views/common/table-column-filters-view.js
// module id = 289
// module chunks = 0